import * as yup from 'yup';

/**
 * use in authentication page > Mobile
 * @param {*} intl
 */
const emailSchema = intl => yup.object().shape({
  emailAddress: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.emailRequired' }))
    .email(intl.formatMessage({ id: 'validation.invalidEmailFormat' })),
});

export default emailSchema;
